import type { BaseIconProps } from "@/assets/icons/geist/utils";
import type { FC } from "react";

export const IconSSH: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}
                >
                    <path
                        d="M0.875 1.125L5.65761 5.90761L0.875 10.6902"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                    />
                    <path
                        d="M5.125 12.875L11.125 12.875"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}
                >
                    <path
                        d="M1 1L7.08696 7.08696L1 13.1739"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path d="M5.26086 15H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}
                >
                    <path
                        d="M3 3L10.8261 10.8261L3 18.6522"
                        stroke="currentColor"
                        strokeWidth="2.1"
                        strokeLinecap="round"
                    />
                    <path d="M8.47827 21H21" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" />
                </svg>
            );
    }
};
